import { Component, OnInit, Inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Ordered } from 'src/app/models/ordered';
import { OrderedService } from 'src/app/services/ordered.service';
import { OrderedFail } from 'src/app/models/ordered-fail';

@Component({
  selector: 'app-ordered-fail-dialog',
  templateUrl: './ordered-fail-dialog.component.html',
  styleUrls: ['./ordered-fail-dialog.component.scss']
})
export class OrderedFailDialogComponent implements OnInit {

  public displayedFailColumns: string[] = ['icon', 'date', 'name', 'code', 'message', 'total'];

  public orderedFailDataSource: MatTableDataSource<any>;

  constructor(public _orderdService: OrderedService,
    @Inject(MAT_DIALOG_DATA) public data: Ordered[]) { }

  ngOnInit() {

    this._orderdService.loadCieloCodes()

    let array: any[] = []

    this.data.forEach((order) => {
      let orderedFail: OrderedFail = new OrderedFail()
      orderedFail.date = order.date
      orderedFail.name = order.member_name
      orderedFail.total = order.total
      orderedFail.code = order.returnCode
      orderedFail.message = this._orderdService.getCieloMessage(order.returnCode)

      array.push(orderedFail)
    })

    this.orderedFailDataSource = new MatTableDataSource(array)

  }

}
